// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
//  <div class="my-5" data-controller="find-or-create-fields" data-find-or-create-fields-hidden-class-value="hidden">
//    <div data-find-or-create-fields-target="findFields">
//      <div class="mb-3">
//        <%= form.label :cardholder_id, class: "" %>
//        <%= form.collection_select :cardholder_id,
//              Cardholder.all.order(name: :asc),
//              :id, :option_text,
//              { prompt: "Select a cardholder..." },
//              { class: "" } %>
//      </div>
//
//      <span class="italic mr-3">or...</span>
//      <button type="button" data-action="find-or-create-fields#showCreateFields">
//        Create a new cardholder
//      </button>
//    </div>
//
//    <fieldset data-find-or-create-fields-target="createFields" class="hidden border rounded p-3 -mx-3">
//      <legend class="px-1 -mx-1">Cardholder</legend>
//
//      <%= form.fields_for :cardholder, Cardholder.new do |fields| %>
//        <span class="italic mr-3">or...</span>
//        <button type="button" class="mb-3" data-action="find-or-create-fields#showFindFields">
//          Discard and select cardholder
//        </button>
//
//        <div class="space-y-5">
//          <div class="">
//            <%= fields.label :tester_id, class: form_label_classes %>
//            <%= fields.collection_select :tester_id,
//                  Tester.all.order(first_name: :asc, last_name: :asc),
//                  :id, :option_text,
//                  { prompt: "Select a tester..." },
//                  { class: "" } %>
//          </div>
//
//          <div class="">
//            <%= fields.label :address_id, class: form_label_classes %>
//            <%= fields.collection_select :address_id,
//                  Address.all.order(name: :asc),
//                  :id, :name,
//                  { prompt: "Select an address..." },
//                  { class: "" } %>
//          </div>
//        </div>
//      <% end %>
//    </fieldset>
//  </div>
//

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "findFields", "createFields", "header" ]
  static values = {
    hiddenClass: {
      type: String,
      default: "hidden"
    }
  }

  connect() {
    this.element[this.identifier] = this
    this.fieldsSelector = 'input:not(.trix-input), select, textarea, trix-editor'

    if (this.hasHeaderTarget) {
      if (this.createFieldsTarget.classList.contains(this.hiddenClassValue)) {
        this.headerTarget.classList.add(this.hiddenClassValue)
      } else {
        this.headerTarget.classList.remove(this.hiddenClassValue)
      }
    }
  }

  showFindFields(event) {
    this.findFieldsTarget.classList.remove(this.hiddenClassValue)
    this.findFieldsTarget.querySelectorAll(this.fieldsSelector).forEach(field => field.disabled = false)
    this.createFieldsTarget.classList.add(this.hiddenClassValue)

    // Mark every nested fieldset inside createFields for removal:
    // persisted rows get _destroy=1 so Rails deletes them on submit,
    // unsaved rows are dropped from the DOM entirely.
    this.createFieldsTarget.querySelectorAll('[data-nested-form-target="fieldSet"]').forEach(fs => {
      if (fs.dataset.newRecord === 'false') {
        const destroyField = fs.querySelector("input[name*='_destroy']")
        if (destroyField) destroyField.value = 1
        fs.classList.add(this.hiddenClassValue)
      } else {
        fs.remove()
      }
    })

    // Disable remaining inputs in createFields so they don't get submitted,
    // but keep the hidden id/_destroy fields enabled so Rails actually
    // processes the deletions above.
    this.createFieldsTarget.querySelectorAll(this.fieldsSelector).forEach(field => {
      if (field.name && (field.name.endsWith('[_destroy]') || field.name.endsWith('[id]'))) return
      field.disabled = true
    })

    if (this.hasHeaderTarget) {
      this.headerTarget.classList.add(this.hiddenClassValue)
    }

    requestAnimationFrame(() => this.findFieldsTarget.querySelector(this.fieldsSelector).focus())
  }

  showCreateFields(event) {
    this.findFieldsTarget.classList.add(this.hiddenClassValue)
    this.findFieldsTarget.querySelectorAll(this.fieldsSelector).forEach(field => field.disabled = true)
    this.createFieldsTarget.classList.remove(this.hiddenClassValue)
    this.createFieldsTarget.querySelectorAll(this.fieldsSelector).forEach(field => field.disabled = false)

    requestAnimationFrame(() => this.createFieldsTarget.querySelector(this.fieldsSelector).focus())

    if (this.hasHeaderTarget) {
      this.headerTarget.classList.remove(this.hiddenClassValue)
    }
  }
}
